// src/components/ProtectedRoute.jsx
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function ProtectedRoute({ children, roles }) {
  const { user, profile, loading } = useAuth();

  if (loading) return (
    <div className="loading-center">
      <div className="spinner" />
    </div>
  );

  if (!user) return <Navigate to="/login" replace />;

  if (profile?.suspended) {
    return (
      <div className="page-content" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', textAlign: 'center' }}>
        <div>
          <h2 style={{ color: '#ef4444', marginBottom: '1rem' }}>الحساب معلق</h2>
          <p className="text-muted">نعتذر، تم تعليق حسابك. يرجى مراجعة إدارة المنصة.</p>
        </div>
      </div>
    );
  }

  if (roles && profile && !roles.includes(profile.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export function PaidRoute({ children }) {
  const { user, profile, loading } = useAuth();

  if (loading) return (
    <div className="loading-center">
      <div className="spinner" />
    </div>
  );

  if (!user) return <Navigate to="/login" replace />;
  if (!profile) return <div className="loading-center"><div className="spinner" /></div>;

  if (profile.subscription !== "paid" || profile.status !== "active") {
    return <Navigate to="/payment" replace />;
  }

  return children;
}
